// Paginate long chart tables at 10 rows, matching the WordPress Ninja Tables widget.
(function () {
  function init() {
    var PER_PAGE = 10;
    document.querySelectorAll('.awad-chart-page__content table').forEach(function (table) {
      var body = table.tBodies[0];
      if (!body) return;
      var rows = Array.prototype.slice.call(body.rows);
      if (rows.length <= PER_PAGE + 2) return;
      var pages = Math.ceil(rows.length / PER_PAGE);
      var current = 0;

      var nav = document.createElement('div');
      nav.className = 'awad-chart-pagination';
      table.parentNode.insertBefore(nav, table.nextSibling);

      function render() {
        rows.forEach(function (row, i) {
          row.style.display = (i >= current * PER_PAGE && i < (current + 1) * PER_PAGE) ? '' : 'none';
        });
        nav.innerHTML = '';
        function btn(label, page, disabled, active) {
          var b = document.createElement('button');
          b.type = 'button';
          b.innerHTML = label;
          if (disabled) b.disabled = true;
          if (active) b.className = 'is-active';
          b.addEventListener('click', function () { current = page; render(); });
          nav.appendChild(b);
        }
        btn('&laquo;', 0, current === 0, false);
        btn('&lsaquo;', Math.max(0, current - 1), current === 0, false);
        for (var p = 0; p < pages; p += 1) btn(String(p + 1), p, false, p === current);
        btn('&rsaquo;', Math.min(pages - 1, current + 1), current === pages - 1, false);
        btn('&raquo;', pages - 1, current === pages - 1, false);
      }
      render();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
